@if (this.actionStack!.getValue('elCModeFonctionnement') === 5) {
  <app-small-tuile
    type="icon"
    icon="fa-kit fa-picto-electrolyseur"
    [title]="'P00037.dashboard.electrolyseur' | translate"
    [content]="'fa-regular fa-warning'"
    [color]="'color-orange'"
    [status]="'TEST CELLULE'"
    (onPress)="this.openProductModal()"
  >
  </app-small-tuile>
} @else {
  <app-small-tuile
    type="icon"
    icon="fa-kit fa-picto-electrolyseur"
    [title]="'P00037.dashboard.electrolyseur' | translate"
    [content]="
      getButtons()[this.actionStack!.getValue('elCModeFonctionnement')].icon!
    "
    [mode]="
      getButtons()[this.actionStack!.getValue('elCModeFonctionnement')].title!
        | translate
    "
    [color]="
      getButtons()[this.actionStack!.getValue('elCModeFonctionnement')].color!
    "
    [status]="
      getStatus(this.actionStack!.getValue('elSEtatProduction')).title!
        | translate
    "
    [statusMode]="
      getStatus(this.actionStack!.getValue('elSEtatProduction')).status!
    "
    (onPress)="this.openProductModal()"
  >
  </app-small-tuile>
}
